<template>
  <div id="user-list">
    <colaborador-list-add-new
      v-model="isAddNewColaboradorSidebarActive"
      @refetch-data="getColaboradores"
    />

    <contadores
      :total-util="totalUtil"
      :ativos="ativos"
    />

    <!-- list filters -->
    <v-card>
      <v-card-title> Filtrar </v-card-title>
      <v-row
        class="px-2 ma-0"
        justify="space-between"
      >
        <!-- role filter -->
        <v-col
          cols="12"
          sm="3"
        >
          <v-select
            v-model.trim="filtroStatus"
            no-data-text="Sem status ativos"
            placeholder="Status"
            :items="opcoes"
            item-text="title"
            item-value="value"
            outlined
            dense
            clearable
            hide-details
            @change="getColaboradores"
          />
        </v-col>

        <!-- plan filter -->
        <v-col
          cols="12"
          sm="4"
        >
          <v-select
            v-model.trim="filtroDepartamento"
            placeholder="Departamento"
            :items="departamentos"
            item-text="[nome]"
            item-value="[nome]"
            outlined
            dense
            clearable
            hide-details
          />
        </v-col>

        <!-- status filter -->
        <v-col
          cols="12"
          sm="3"
        >
          <v-select
            v-model.trim="filtroCargo"
            placeholder="Cargo"
            :items="cargos"
            item-text="nome"
            item-value="nome"
            outlined
            dense
            clearable
            hide-details
          />
        </v-col>
      </v-row>
      <v-col
        cols="12"
        sm="3"
      >
        <v-select
          v-model="filtroAtuacao"
          placeholder="Atuação"
          :items="atuacoes"
          item-text="title"
          item-value="value"
          outlined
          dense
          clearable
          hide-details
        />
      </v-col>

      <div class="d-flex flex-md-row flex-column px-5 mt-3 justify-space-between">
        <v-btn
          class="mb-md-0 mb-3"
          color="secondary"
          outlined
          @click="limparFiltros"
        >
          Limpar filtros
        </v-btn>

        <v-btn
          class="mb-md-0 mb-6"
          color="secondary"
          outlined
          @click="getColaboradores"
        >
          Filtrar
        </v-btn>
      </div>

      <v-divider class="mt-4"></v-divider>

      <!-- actions -->
      <v-card-text class="d-flex align-center flex-wrap pb-0">
        <!-- search -->
        <v-text-field
          v-model.trim="search"
          placeholder="Pesquisar"
          outlined
          hide-details
          dense
          class="user-search me-3 mb-4"
          @keyup="getColaboradores"
        />

        <v-spacer></v-spacer>

        <div class="d-flex align-center flex-wrap">
          <v-btn
            v-if="!acessoPost"
            color="primary"
            class="mb-4 px-4"
            disabled
            @click.stop="isAddNewColaboradorSidebarActive = !isAddNewColaboradorSidebarActive"
          >
            <v-icon
              left
              size="25"
              class="mr-1"
            >
              {{ icons.mdiPlus }}
            </v-icon>
            <span>Criar</span>
          </v-btn>
          <v-btn
            v-else
            color="primary"
            class="mb-4 px-4"
            @click.stop="isAddNewColaboradorSidebarActive = !isAddNewColaboradorSidebarActive"
          >
            <v-icon
              left
              size="25"
              class="mr-1"
            >
              {{ icons.mdiPlus }}
            </v-icon>
            <span>Criar</span>
          </v-btn>
        </div>
      </v-card-text>

      <v-col cols="12">
        <div style="min-height: 4px">
          <v-progress-linear
            v-if="loading"
            indeterminate
          />
        </div>

        <table-colaborador
          :items="colaboradores"
          :acesso-disable="acessoDisable"
          @confirmar-inativacao="getColaboradores"
        />
      </v-col>
    </v-card>
  </div>
</template>

<style lang="scss">
@import '@core/preset/preset/apps/user.scss';
</style>

<script>
import { onMounted, ref } from '@vue/composition-api'
import { storeToRefs } from 'pinia'
import { mdiPlus } from '@mdi/js'
import TableColaborador from '@/components/tables/TableColaborador.vue'
import Contadores from '@/views/colaborador/contadores.vue'
import ColaboradorListAddNew from './ColaboradorListAddNew.vue'
import useAuthStore from '@/store/auth'
import ColaboradorService from '@/services/modules/ColaboradorService'
import CargoService from '@/services/modules/CargoService'
import DepartamentoService from '@/services/modules/DepartamentoService'

export default {
  components: {
    ColaboradorListAddNew,
    TableColaborador,
    Contadores,
  },

  setup() {
    const isAddNewColaboradorSidebarActive = ref(false)

    const opcoes = [
      { title: 'Inativos', value: 'false' },
      { title: 'Ativos', value: 'true' },
    ]
    const atuacoes = [
      { title: 'Gestor', value: 1 }, // ajusta os ids conforme o banco
      { title: 'Agente', value: 2 },
    ]

    const filtroAtuacao = ref(null)
    const { funcionalidades } = storeToRefs(useAuthStore())

    const colaboradores = ref([])
    const cargos = ref([])
    const departamentos = ref([])
    const loading = ref(true)
    const search = ref('')
    const filtroStatus = ref(null)
    const filtroDepartamento = ref(null)
    const filtroCargo = ref(null)
    const ativos = ref([])
    const totalUtil = ref([])
    const idPost = 1018
    const idDisable = 1020
    const acessoPost = ref(true)
    const acessoDisable = ref(true)

    function permissoes() {
      if (!funcionalidades.value.includes(idPost)) {
        acessoPost.value = false
      }
      if (!funcionalidades.value.includes(idDisable)) {
        acessoDisable.value = false
      }
    }

    async function getColaboradores() {
      try {
        const data = await ColaboradorService.get()

        colaboradores.value = data
        totalUtil.value = colaboradores.value
        ativos.value = colaboradores.value.filter(i => i.ativo)

        colaboradores.value = colaboradores.value
          .filter(ut => (ut.nome.toLowerCase().includes(search.value.toLowerCase())
          || ut.login.toLowerCase().includes(search.value.toLowerCase()))
           && (ut.departamentoNome === filtroDepartamento.value || !filtroDepartamento.value) // 👈
          && (ut.ativo.toString() === filtroStatus.value || !filtroStatus.value)
          && (ut.cargoNome === filtroCargo.value || !filtroCargo.value)
          && (ut.atuacaoId === filtroAtuacao.value || !filtroAtuacao.value))
          .sort((a, b) => new Date(b.dataCadastro) - new Date(a.dataCadastro))
        setTimeout(() => {
          loading.value = false
        }, 1000)
      } catch {
        loading.value = false
      }
    }

    async function getCargos() {
      cargos.value = await CargoService.get()
    }

    async function getDepartamentos() {
      departamentos.value = await DepartamentoService.get()
    }

    function limparFiltros() {
      filtroStatus.value = null
      filtroDepartamento.value = null
      filtroCargo.value = null
      filtroAtuacao.value = null
      getColaboradores()
    }

    onMounted(() => {
      getColaboradores()
      getCargos()
      getDepartamentos()
      // permissoes()
    })

    return {
      isAddNewColaboradorSidebarActive,
      opcoes,
      atuacoes,
      colaboradores,
      cargos,
      departamentos,
      loading,
      search,
      filtroStatus,
      filtroDepartamento,
      filtroCargo,
      ativos,
      filtroAtuacao,
      totalUtil,
      acessoPost,
      acessoDisable,
      getColaboradores,
      getCargos,
      getDepartamentos,
      limparFiltros,
      icons: {
        mdiPlus,
      },
    }
  },
}
</script>
